export const ADD_TO_SAVED = {
  displayToast: true,
  mainText: 'Item added',
  linkText: 'View saved products',
  linkUrl: '/saved#products',
}

export const REMOVE_FROM_SAVED = {
  displayToast: true,
  mainText: 'Item removed',
}

export const REMOVE_ARTICLE_FROM_SAVED = {
  displayToast: true,
  mainText: 'Article removed from saved items',
}

export const SAVE_ERROR = {
  displayToast: true,
  error: true,
  mainText: 'Sorry, there was an error. Try again.',
}
